import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_FORMATS } from '@app/shared/helpers/date.adapter';
import * as moment from 'moment';
@Component({
  selector: 'dateControl',
  templateUrl: './date-control.component.html',
  styleUrls: ['./date-control.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class DateControlComponent implements OnInit {

  public formGroup: FormGroup;
  @Output() onDatePickerClose = new EventEmitter<boolean>();
  @Input() formControlFieldName: string;
  @Input() placeholder: string = "DDMMYYYY";
  @Input() minDays: number = 0;
  @Input() minDate: Date;
  @Input() maxDate: moment.Moment;
  @Input() mxLength: number = 6;
  @Input() isReadonly: boolean = false;
  @Input() isReadonlyCls: boolean = false;
  @Input() defaultHeight: boolean = true;
  @Input() isAssignments: boolean = false;
  @Input() disableDates: boolean = true;

  constructor(private ctrlContainer: FormGroupDirective) { }

  ngOnInit() {
    if (this.disableDates) {
      if (this.isAssignments) this.minDate = new Date();
    }
    this.formGroup = this.ctrlContainer.form;
    const control = new FormControl('');
    this.formGroup.addControl(this.formControlFieldName, control);
  }

  onClose() {
    this.onDatePickerClose.emit(true);
  }

  validateSelected(event) {
    let x = event.target.value;
    let first = x.substring(0, 2);
    let second = x.substring(3, 5);
    let third = x.substring(6, 10);
    let final = third + '-' + second + '-' + first;
    let a = new Date(final).toISOString().slice(0, 10);
    let b = new Date().toISOString().slice(0, 10);
    if (a < b) {
      this.formGroup.get(this.formControlFieldName).setErrors({ 'past': true });
    }
  }

}